// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ImageSlider.css */


.slideContainer {
  opacity: 0; /* 처음에는 보이지 않음 */
  transition: opacity 1s ease-in-out; /* opacity가 1로 변경될 때 1초 동안 부드럽게 변화 */
  position: relative;
}

.slideContainer.fade-in {
  opacity: 1; /* fade-in 클래스가 추가되면 점점 선명해짐 */
}

.slideImg {
  width: 130%;
  object-Fit: cover;
}

.slick-slide img {
  transition: opacity 0.5s ease-in-out;
  opacity: 0;
}

.slick-active img {
  opacity: 1;
  /* 현재 활성화된 슬라이드는 완전히 보이도록 설정 */
}


.text-overlay {
  position: absolute;
  width: 100%;
  Height: 100%;
  top: 20%;
  left: 0%;
  font-weight: bold;
  z-index: 10;  /* 텍스트가 이미지 위에 표시되도록 설정 */
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.text-position {
  position: absolute;
  top: 25%;
  left: 5%;
}
.text-main-1 {
  color: white;
  padding: 0;
  margin: 0;
  opacity: 0.8;
  text-shadow:
    -1px -1px 0 #000,
     1px -1px 0 #000,
    -1px  1px 0 #000,
     1px  1px 0 #000;
}

.text-main-2 {
  color: white;
  padding: 0;
  margin: 0;
  opacity: 0.8;
  text-shadow:
    -1px -1px 0 #000,
     1px -1px 0 #000,
    -1px  1px 0 #000,
     1px  1px 0 #000;
}

.text-main-3 {
  color: white;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
}

.text-box {
  position: absolute;
}

.text-fix {
  position: absolute;
  top: 100%;
  left: 0%;
  color: white;
  opacity: 0.7;
  transition: opacity 1s ease-in-out; /* 2초 지연 후 서서히 나타남 */
  text-shadow:
    -1px -1px 0 #000,
     1px -1px 0 #000,
    -1px  1px 0 #000,
     1px  1px 0 #000;
}

.text-fix.show {
  opacity: 1;
}



.custom-pagination .swiper-pagination-bullet {
  
  width: 12px;
  height: 12px;
  border: 1px solid white; /* 흰색 테두리 */
  background-color: transparent; /* 내부 투명 */
  border-radius: 50%;
  opacity: 1;
  transition: background-color 0.3s, opacity 0.3s;
  
}

.custom-pagination .swiper-pagination-bullet-active {
  background-color: white; /* 선택된 bullet은 흰색 */
  border-color: white; /* 테두리 유지 */
  opacity: 1;
  top: "25%" !important;
}

.custom-pagination {
  position: absolute !important;
  top: 25% !important;
  left: 5% !important;
  z-index: 10 !important;
  display: flex !important;
  width: 50% !important;
}

/* 화면 너비가 767px 이하일 때 텍스트 크기 줄이기 */
@media (max-width: 767px) {

  .slideImg {
    width: 100%;
    object-Fit: cover;
    height:300px;
  }
  
  .custom-pagination {
    top: 40% !important;
  }

  .custom-pagination .swiper-pagination-bullet {
    width: 5px;
    height: 5px;
  }

  .text-overlay {
    font-size: 64px; /* 작은 화면에서는 텍스트 크기를 고정 */
  }

  .text-main-1 {
    font-size: 15px;
  }
  
  .text-main-2 {
    font-size: 30px;
  }
  
  .text-fix {
    font-size: 15px;
  }
}

@media (min-width: 768px) and (max-width: 1749px)  {

  .custom-pagination {
    top: 42% !important;
  }
  
  .text-main-1 {
    font-size: 30px;
  }
  
  .text-main-2 {
    font-size: 70px;
  }
  
  .text-fix {
    font-size: 30px;
  }
}

/* 화면 너비가 1200px 이상일 때 텍스트 크기 크게 설정 */
@media (min-width: 1750px) {

  .custom-pagination {
    top: 35% !important;
  }

  .text-position {
    top: 20%;
  }

  .text-main-1 {
    font-size: 50px;
  }
  
  .text-main-2 {
    font-size: 142px;
  }
  
  .text-fix {
    font-size: 50px;
  }

}
`, "",{"version":3,"sources":["webpack://./src/components/ImageSlider.css"],"names":[],"mappings":"AAAA,oBAAoB;;;AAGpB;EACE,UAAU,EAAE,gBAAgB;EAC5B,kCAAkC,EAAE,oCAAoC;EACxE,kBAAkB;AACpB;;AAEA;EACE,UAAU,EAAE,8BAA8B;AAC5C;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,8BAA8B;AAChC;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,QAAQ;EACR,iBAAiB;EACjB,WAAW,GAAG,yBAAyB;EACvC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;AACV;AACA;EACE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,YAAY;EACZ;;;;oBAIkB;AACpB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,YAAY;EACZ;;;;oBAIkB;AACpB;;AAEA;EACE,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,kCAAkC,EAAE,oBAAoB;EACxD;;;;oBAIkB;AACpB;;AAEA;EACE,UAAU;AACZ;;;;AAIA;;EAEE,WAAW;EACX,YAAY;EACZ,uBAAuB,EAAE,WAAW;EACpC,6BAA6B,EAAE,UAAU;EACzC,kBAAkB;EAClB,UAAU;EACV,+CAA+C;;AAEjD;;AAEA;EACE,uBAAuB,EAAE,mBAAmB;EAC5C,mBAAmB,EAAE,WAAW;EAChC,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA,kCAAkC;AAClC;;EAEE;IACE,WAAW;IACX,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,eAAe,EAAE,wBAAwB;EAC3C;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;EAEE;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,qCAAqC;AACrC;;EAEE;IACE,mBAAmB;EACrB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;AAEF","sourcesContent":["/* ImageSlider.css */\n\n\n.slideContainer {\n  opacity: 0; /* 처음에는 보이지 않음 */\n  transition: opacity 1s ease-in-out; /* opacity가 1로 변경될 때 1초 동안 부드럽게 변화 */\n  position: relative;\n}\n\n.slideContainer.fade-in {\n  opacity: 1; /* fade-in 클래스가 추가되면 점점 선명해짐 */\n}\n\n.slideImg {\n  width: 130%;\n  object-Fit: cover;\n}\n\n.slick-slide img {\n  transition: opacity 0.5s ease-in-out;\n  opacity: 0;\n}\n\n.slick-active img {\n  opacity: 1;\n  /* 현재 활성화된 슬라이드는 완전히 보이도록 설정 */\n}\n\n\n.text-overlay {\n  position: absolute;\n  width: 100%;\n  Height: 100%;\n  top: 20%;\n  left: 0%;\n  font-weight: bold;\n  z-index: 10;  /* 텍스트가 이미지 위에 표시되도록 설정 */\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.text-position {\n  position: absolute;\n  top: 25%;\n  left: 5%;\n}\n.text-main-1 {\n  color: white;\n  padding: 0;\n  margin: 0;\n  opacity: 0.8;\n  text-shadow:\n    -1px -1px 0 #000,\n     1px -1px 0 #000,\n    -1px  1px 0 #000,\n     1px  1px 0 #000;\n}\n\n.text-main-2 {\n  color: white;\n  padding: 0;\n  margin: 0;\n  opacity: 0.8;\n  text-shadow:\n    -1px -1px 0 #000,\n     1px -1px 0 #000,\n    -1px  1px 0 #000,\n     1px  1px 0 #000;\n}\n\n.text-main-3 {\n  color: white;\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);\n}\n\n.text-box {\n  position: absolute;\n}\n\n.text-fix {\n  position: absolute;\n  top: 100%;\n  left: 0%;\n  color: white;\n  opacity: 0.7;\n  transition: opacity 1s ease-in-out; /* 2초 지연 후 서서히 나타남 */\n  text-shadow:\n    -1px -1px 0 #000,\n     1px -1px 0 #000,\n    -1px  1px 0 #000,\n     1px  1px 0 #000;\n}\n\n.text-fix.show {\n  opacity: 1;\n}\n\n\n\n.custom-pagination .swiper-pagination-bullet {\n  \n  width: 12px;\n  height: 12px;\n  border: 1px solid white; /* 흰색 테두리 */\n  background-color: transparent; /* 내부 투명 */\n  border-radius: 50%;\n  opacity: 1;\n  transition: background-color 0.3s, opacity 0.3s;\n  \n}\n\n.custom-pagination .swiper-pagination-bullet-active {\n  background-color: white; /* 선택된 bullet은 흰색 */\n  border-color: white; /* 테두리 유지 */\n  opacity: 1;\n  top: \"25%\" !important;\n}\n\n.custom-pagination {\n  position: absolute !important;\n  top: 25% !important;\n  left: 5% !important;\n  z-index: 10 !important;\n  display: flex !important;\n  width: 50% !important;\n}\n\n/* 화면 너비가 767px 이하일 때 텍스트 크기 줄이기 */\n@media (max-width: 767px) {\n\n  .slideImg {\n    width: 100%;\n    object-Fit: cover;\n    height:300px;\n  }\n  \n  .custom-pagination {\n    top: 40% !important;\n  }\n\n  .custom-pagination .swiper-pagination-bullet {\n    width: 5px;\n    height: 5px;\n  }\n\n  .text-overlay {\n    font-size: 64px; /* 작은 화면에서는 텍스트 크기를 고정 */\n  }\n\n  .text-main-1 {\n    font-size: 15px;\n  }\n  \n  .text-main-2 {\n    font-size: 30px;\n  }\n  \n  .text-fix {\n    font-size: 15px;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 1749px)  {\n\n  .custom-pagination {\n    top: 42% !important;\n  }\n  \n  .text-main-1 {\n    font-size: 30px;\n  }\n  \n  .text-main-2 {\n    font-size: 70px;\n  }\n  \n  .text-fix {\n    font-size: 30px;\n  }\n}\n\n/* 화면 너비가 1200px 이상일 때 텍스트 크기 크게 설정 */\n@media (min-width: 1750px) {\n\n  .custom-pagination {\n    top: 35% !important;\n  }\n\n  .text-position {\n    top: 20%;\n  }\n\n  .text-main-1 {\n    font-size: 50px;\n  }\n  \n  .text-main-2 {\n    font-size: 142px;\n  }\n  \n  .text-fix {\n    font-size: 50px;\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
